/* Free shipping bar: refresh after any cart change (Husnain, 2026-10). */
(function () {
  var money = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
  var pending = null;

  function render(cart) {
    document.querySelectorAll('[data-gt-fsb]').forEach(function (bar) {
      var goal = parseInt(bar.getAttribute('data-goal'), 10) || 5995;
      var total = cart.total_price;
      var remaining = goal - total;
      var msg = bar.querySelector('[data-gt-fsb-msg]');
      var fill = bar.querySelector('[data-gt-fsb-fill]');
      if (total === 0) {
        msg.innerHTML = 'Free shipping for orders over <strong>' + money.format(goal / 100) + '</strong>';
      } else if (remaining > 0) {
        msg.innerHTML = 'Only <strong>' + money.format(remaining / 100) + '</strong> away from free shipping';
      } else {
        msg.textContent = "Congratulations! You've got free shipping";
      }
      if (fill) fill.style.width = Math.min(100, Math.round(total * 100 / goal)) + '%';
    });
  }

  function refresh() {
    clearTimeout(pending);
    pending = setTimeout(function () {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () {});
    }, 300);
  }

  // Catches cart requests from the theme (jQuery), apps and Shopify scripts without patching them.
  if ('PerformanceObserver' in window) {
    new PerformanceObserver(function (list) {
      list.getEntries().forEach(function (entry) {
        if (/\/cart\/(add|change|update|clear)(\.js)?/.test(entry.name)) refresh();
      });
    }).observe({ type: 'resource', buffered: false });
  }
  // The cart can change in another tab or from the back/forward cache.
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
})();
